import script from "./TermsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./TermsModal.vue?vue&type=script&setup=true&lang=ts"

import "./TermsModal.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__